import React from 'react';
import { motion } from 'framer-motion';
import { MessageCircle, Sparkles, CheckCircle2, FileText, FileBarChart, Search } from 'lucide-react';
export function HowItWorksSection() {
  const steps = [{
    number: '1',
    title: 'WhatsApp real',
    description: 'Fotos, audios y mensajes enviados como siempre.',
    icon: <MessageCircle className="w-7 h-7 text-blue-600" data-id="element-139" />
  }, {
    number: '2',
    title: 'Obra Digital ordena',
    description: 'Clasifica, resume y respalda automáticamente.',
    icon: <Sparkles className="w-7 h-7 text-blue-600" data-id="element-140" />
  }, {
    number: '3',
    title: 'Todo queda disponible',
    description: 'Historial, informes y búsqueda instantánea.',
    icon: <CheckCircle2 className="w-7 h-7 text-blue-600" data-id="element-141" />
  }];
  const deliverables = [{
    icon: <MessageCircle className="w-5 h-5 text-blue-600" data-id="element-142" />,
    title: 'Conversación real'
  }, {
    icon: <FileText className="w-5 h-5 text-blue-600" data-id="element-143" />,
    title: 'Resumen automático'
  }, {
    icon: <FileBarChart className="w-5 h-5 text-blue-600" data-id="element-144" />,
    title: 'Informe PDF'
  }, {
    icon: <Search className="w-5 h-5 text-blue-600" data-id="element-145" />,
    title: 'Historial searchable'
  }];
  return <section id="como-funciona" className="scroll-mt-20 py-12 sm:py-16 bg-white" data-id="element-146">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-147">
        <div className="text-center mb-10 sm:mb-14 max-w-2xl mx-auto" data-id="element-148">
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-extrabold text-gray-900 mb-3 sm:mb-4 tracking-tight" data-id="element-149">
            Así funciona
          </h2>
          <p className="text-sm sm:text-base lg:text-lg text-gray-600 leading-relaxed" data-id="element-150">
            Tu equipo sigue usando WhatsApp. Obra Digital transforma esa
            conversación en historial, búsqueda e informes.
          </p>
        </div>

        {/* Steps */}
        <div className="relative mb-12 sm:mb-16" data-id="element-151">
          <div className="hidden md:block absolute top-9 left-0 w-full h-0.5 bg-gray-200 z-0" data-id="element-152" />
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 sm:gap-10 relative z-10" data-id="element-153">
            {steps.map((step, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.15
          }} className="flex flex-col items-center text-center" data-id="element-154">
                <div className="relative mb-5" data-id="element-155">
                  <div className="w-[72px] h-[72px] bg-white rounded-2xl border-2 border-gray-100 shadow-sm flex items-center justify-center" data-id="element-156">
                    {step.icon}
                  </div>
                  <div className="absolute -top-2.5 -right-2.5 w-7 h-7 bg-blue-600 text-white rounded-full flex items-center justify-center font-bold text-xs border-2 border-white shadow-sm" data-id="element-157">
                    {step.number}
                  </div>
                </div>
                <h3 className="text-base font-bold text-gray-900 mb-1.5 leading-snug" data-id="element-158">
                  {step.title}
                </h3>
                <p className="text-sm text-gray-600 max-w-[260px] leading-relaxed" data-id="element-159">
                  {step.description}
                </p>
              </motion.div>)}
          </div>
        </div>

        {/* Deliverables */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-2.5 sm:gap-4 max-w-5xl mx-auto" data-id="element-160">
          {deliverables.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.06
        }} className="flex items-center gap-2.5 sm:gap-3 bg-gray-50 border border-gray-200 rounded-xl px-3 sm:px-4 py-2.5 sm:py-3" data-id="element-161">
              <div className="w-8 h-8 sm:w-9 sm:h-9 rounded-lg bg-blue-50 flex items-center justify-center flex-shrink-0" data-id="element-162">
                {item.icon}
              </div>
              <span className="text-xs sm:text-sm font-semibold text-gray-900 leading-snug" data-id="element-163">
                {item.title}
              </span>
            </motion.div>)}
        </div>
      </div>
    </section>;
}